import {
  __name
} from "./chunk-SHUYVCID.js";

// src/sections/new/form-section/submit-form.ts
import { R } from "@mobily/ts-belt";
import axios from "axios";
var GENERIC_FAILURE_MESSAGE = "We could not send your message. Please try again,\
 or email us directly.";
function resolveErrorMessage(data) {
  const firstError = data?.errors?.[0]?.message;
  return firstError != null && firstError.length > 0 ? firstError : GENERIC_FAILURE_MESSAGE;
}
__name(resolveErrorMessage, "resolveErrorMessage");
async function submitFormToEndpoint(endpoint, formData) {
  const response = await axios.post(endpoint, formData, {
    headers: { Accept: "application/json" },
    timeout: 15e3,
    validateStatus: /* @__PURE__ */ __name(() => true, "validateStatus")
  }).catch(() => null);
  if (response == null) {
    return R.Error({ message: GENERIC_FAILURE_MESSAGE });
  }
  if (response.status >= 200 && response.status < 300) {
    return R.Ok(true);
  }
  return R.Error({ message: resolveErrorMessage(response.data) });
}
__name(submitFormToEndpoint, "submitFormToEndpoint");

export {
  submitFormToEndpoint
};
